<template>
  <!-- HTML COMPUTADOR-->
  <div class="hidden-sm hidden-xs">

    <header class="main_menu home_menu">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <nav class="navbar navbar-expand-lg navbar-light">

              <router-link to="/" class="navbar-brand"><img :src="$imagens + 'logo.jpeg'" alt=""></router-link>

              <div class="collapse navbar-collapse main-menu-item" id="navbarNav">
                <ul class="navbar-nav">
                  <li class="nav-item">
                    <router-link to="/" class="nav-link">Home</router-link>
                  </li>

                  <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      Produtos
                    </a>
                    <ul v-if="listaProdutos != '' && listaProdutos.length > 0" class="dropdown-menu"
                      aria-labelledby="navbarDropdown">
                      <li v-for="menu in listaProdutos" :key="menu.itiId">
                        <router-link class="dropdown-item"
                          :to="'/ProdutosDetalhe/' + menu.itiId + '/' + formataLink(menu.itiNome)">{{
                            menu.itiNome }}</router-link>
                      </li>
                    </ul>
                  </li>

                  <li class="nav-item">
                    <router-link to="/sobre" class="nav-link">Sobre Nós</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link to="/blog" class="nav-link">Notícias</router-link>
                  </li>

                  <li class="nav-item">
                    <router-link to="/contato" class="nav-link">Contato</router-link>
                  </li>
                </ul>
              </div>
              <div v-if="topoMenu && topoMenu.length > 0" class="btn_1 d-none d-lg-block">
                <a :href="topoMenu[0].itiReferencia" class="float-right" target="_blank">
                  <i class="fa fa-whatsapp"></i> {{ topoMenu[0].itiNome }}
                </a>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </header>

  </div>

  <!-- HTML CELULAR -->
  <div class="container hidden-lg hidden-md" style="position:absolute; z-index: 3; background-color: #FFF;">
    <div class="row celular-alinhado">
      <div class="col-3">
        <v-menu :close-on-content-click="true">
          <template v-slot:activator="{ props }">
            <v-btn icon="mdi-dots-vertical" v-bind="props"></v-btn>
          </template>
          <v-list class="celular-topo">
            <v-list-item><router-link to="/"><v-list-item-title
                  class=" menu">Home</v-list-item-title></router-link></v-list-item>
            <v-list-item><router-link to="/sobre"><v-list-item-title
                  class=" menu">Sobre</v-list-item-title></router-link></v-list-item>
            <v-list-item v-for="menu in listaProdutos" :key="menu.itiId"><router-link
                :to="'/ProdutosDetalhe/' + menu.itiId + '/' + formataLink(menu.itiNome + menu.itiReferencia)"><v-list-item-title
                  class=" menu" style="font-weight: 600;">{{ menu.itiNome
                  }}</v-list-item-title></router-link></v-list-item>
            <v-list-item><router-link to="/blog"><v-list-item-title
                  class=" menu">Notícias</v-list-item-title></router-link></v-list-item>
            <v-list-item><router-link to="/contato"><v-list-item-title
                  class=" menu">Contato</v-list-item-title></router-link></v-list-item>
            <v-list-item><router-link :to="topoMenu[0].itiLinkBtn1" target="_blank"
                class="header-btn"><v-list-item-title class=" menu">
                  <i class="fa fa-whatsapp"></i> {{ topoMenu[0].itiNome }}
                </v-list-item-title></router-link></v-list-item>
          </v-list>
        </v-menu>
      </div>
      <div class="col-9">
        <router-link to="/"><img :src="$imagens + 'logo.jpeg'" alt=""></router-link>
      </div>
    </div>
  </div>

</template>

<script>
import axios from 'axios';

export default {
  name: 'PageHeader',
  components: {
  },

  data: () => ({
    topoMenu: [],
    listaProdutos: [],
    showModernizacaoMenu: false,
    return: {
      isMenuOpen: false
    }
  }),

  methods: {
    toggleModernizacaoMenu() {
      this.showModernizacaoMenu = !this.showModernizacaoMenu;
    },

    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },

    formataLink(value) {
      return value.replaceAll('/', '').replaceAll(' ', '-').replaceAll('.', '').replaceAll('+', '');
    },

  },

  created() {

    // WHATSAPP
    axios.get('/Process/InsInstitucional/institucional/9/whatsapp/0/x')
      .then(response => {
        this.topoMenu = response.data;
        //console.log('topoMenu')
        //console.log(this.topoMenu)
      })
      .catch(error => {
        console.error(error);
      });

    // PRODUTOS
    axios.get('/Process/InsInstitucional/institucional/46/listadeprodutos/0/x')
      .then(response => {
        this.listaProdutos = response.data.filter(x => x.itiVisivel).sort((a, b) => {
          const valorA = parseInt(a.itiOrdem) || 0;
          const valorB = parseInt(b.itiOrdem) || 0;
          return valorA - valorB;
        });
        //console.log('listaProdutos')
        //console.log(this.listaProdutos)
      })
      .catch(error => {
        console.error(error);
      });
  }
};
</script>

<style scoped>
.menu {
  line-height: 1.2;
  /* padrão costuma ser 1.5 */
  font-size: 16px;
  font-weight: 400;
  transition: color 0.3s;
  padding: 4px 0;
  /* opcional: controla o espaçamento vertical */
}

.menu:hover {
  color: #0047AB;
  /* muda cor ao passar o mouse */
}

.celular-topo {
  padding: 0;
  margin: 0;
  background-color: #FFF;
  /* cor de fundo opcional */
  margin-top: 10px;
}

/* reduz altura e espaçamento dos itens */
.celular-topo .v-list-item {
  min-height: 36px;
  /* padrão é 48px */
  padding-top: 6px;
  padding-bottom: 6px;
}

/* estilização dos textos */
.celular-topo .menu {
  font-size: 15px;
  font-weight: 400;
  color: #0047AB;
  line-height: 1.2;
  /* diminui entrelinha */
  transition: color 0.3s ease;
}

/* efeito hover */
.celular-topo .menu:hover {
  color: #FF7E1C;
  /* cor ao passar o mouse */
}

/* botão whatsapp / orçamento */
.celular-topo .header-btn .menu {
  font-weight: 600;
  color: #0047AB;
}

/* opcional: centraliza ícone e texto */
.celular-topo .header-btn i {
  margin-right: 6px;
  font-size: 16px;
  vertical-align: middle;
}

/* remove sublinhado do router-link */
.celular-topo a {
  text-decoration: none;
}

.celular-alinhado {
  display: flex;
  justify-content: space-between;
  justify-content: center;
  align-items: center;
  align-content: center;
  margin-top: 15px;
  margin-bottom: 15px;
  text-align: center;
}
</style>
